module.exports = __webpack_public_path__ + "fa-brands-400.svg?277706fedcf440dfa9fd535ef7285c82";